<script setup lang="ts">
import { useTeamSides } from '@desktop/views/Relation/composables'

import Pitch from './Pitch/Pitch.vue'
import PitchSideIncidents from './PitchSideIncidents.vue'

// composables
const { getParticipantsWithCurrentTeamSides } = useTeamSides()
const { currentFirstParticipant, currentSecondParticipant } =
  getParticipantsWithCurrentTeamSides()
</script>

<template>
  <div class="flex items-center gap-x-[clamp(0.25rem,1vw,1rem)]">
    <PitchSideIncidents
      v-if="currentFirstParticipant"
      :participant="currentFirstParticipant"
    />
    <Pitch />
    <PitchSideIncidents
      v-if="currentSecondParticipant"
      :participant="currentSecondParticipant"
      reversed
    />
  </div>
</template>
